import { type FC } from 'react'
import { type DefaultProps } from '@egw/components'

export const UsbIcon: FC<DefaultProps> = ({ className, id, testId, ariaLabel }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
      fill="none"
      className={className}
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
    >
      <path
        fill="#698679"
        d="M10.786 3.652 8.348 1.214a.304.304 0 0 0-.43 0L6.151 2.98l-.241-.241a.304.304 0 0 0-.431 0L1.908 6.309A2.656 2.656 0 0 0 1.125 8.2c0 1.475 1.2 2.675 2.675 2.675.714 0 1.386-.278 1.89-.784L9.263 6.52a.304.304 0 0 0 0-.43l-.241-.242 1.765-1.765a.304.304 0 0 0 0-.431ZM3.715 9.656a1.373 1.373 0 0 1-1.371-1.37c0-.757.615-1.372 1.37-1.372.757 0 1.372.615 1.372 1.371s-.615 1.371-1.371 1.371Zm.85-3.44a.304.304 0 1 1 .432-.431l1.218 1.218a.304.304 0 1 1-.43.431l-1.22-1.219Zm2.564.304a.304.304 0 0 1-.43 0L5.48 5.301a.304.304 0 1 1 .43-.43l1.22 1.218a.304.304 0 0 1 0 .431Zm1.46-1.103L6.584 3.41l1.55-1.55 2.006 2.007-1.55 1.55Z"
      />
      <path
        fill="#698679"
        d="m7.917 2.738-.457.457a.305.305 0 1 0 .431.43l.457-.456a.305.305 0 1 0-.43-.431ZM8.374 4.54a.305.305 0 0 0 .431 0l.457-.457a.305.305 0 1 0-.43-.431l-.458.457a.305.305 0 0 0 0 .43ZM3.715 7.523a.762.762 0 1 0 .001 1.525.762.762 0 0 0-.001-1.525Z"
      />
    </svg>
  )
}
